"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable:no-server-dependencies-in-client
var serverless_pagination_1 = require("@soluto-private/serverless-pagination");
exports.PaginationSchema = serverless_pagination_1.PaginationSchema;
